<div class="pt-6 border-r lg:h-screen bg-white sticky top-0">
  <div class="flex flex-col">
    <div
      class="flex flex-col justify-start h-screen w-full overflow-auto align-top no-scrollbar"
    >
      <div class="w-full mx-auto">
        <img
          src="assets/svg/cfa-sante.svg"
          class="mx-auto mb-6 cursor-pointer h-16"
          alt="Cfa santé"
          (click)="onClick('ADMINISTRATOR', '/administrateurs')"
        />
      </div>
      <div
        class="flex flex-col h-full relative justify-between lg:w-10/12 mx-auto"
      >
        <div class="flex flex-col gap-4">
          <div
            [ngClass]="
              activeRoute === 'ADMINISTRATOR'
                ? 'bg-percian-green rounded-lg text-white'
                : 'bg-white text-black'
            "
            class="text-sm cursor-pointer mx-4 p-2"
            (click)="onClick('ADMINISTRATOR', '/administrateurs')"
          >
            <p>Administrateurs</p>
          </div>
          <div
            [ngClass]="
              activeRoute === 'POLES'
                ? 'bg-percian-green rounded-lg text-white'
                : 'bg-white text-black'
            "
            class="text-sm cursor-pointer mx-4 p-2"
            (click)="onClick('POLES', '/poles')"
          >
            <p>Pôles</p>
          </div>
          <div
            [ngClass]="
              activeRoute === 'UFA_AND_TRAINING'
                ? 'bg-percian-green rounded-lg text-white'
                : 'bg-white text-black'
            "
            class="text-sm cursor-pointer mx-4 p-2"
            (click)="onClick('UFA_AND_TRAINING', '/ufa')"
          >
            <p>Nos UFA & formations</p>
          </div>
          <div
            [ngClass]="
              activeRoute === 'BUSINESS_CARD'
                ? 'bg-percian-green rounded-lg text-white'
                : 'bg-white text-black'
            "
            class="text-sm cursor-pointer mx-4 p-2"
            (click)="onClick('BUSINESS_CARD', '/fiche-metier')" 
          >
            <p>Nos fiches métiers</p>
          </div>
          <div
            [ngClass]="
              activeRoute === 'FAQ'
                ? 'bg-percian-green rounded-lg text-white'
                : 'bg-white text-black'
            "
            class="text-sm cursor-pointer mx-4 p-2"
            (click)="onClick('FAQ', '/faq')"
          >
            <p>FAQ</p>
          </div>
          <div
            [ngClass]="
              activeRoute === 'NEWS'
                ? 'bg-percian-green rounded-lg text-white'
                : 'bg-white text-black'
            "
            class="text-sm cursor-pointer mx-4 p-2"
            (click)="onClick('NEWS', '/actualites')"
          >
            <p>Actualités</p>
          </div>
          <div
            [ngClass]="
              activeRoute === 'EMPLOYERS_OPINIONS'
                ? 'bg-percian-green rounded-lg text-white'
                : 'bg-white text-black'
            "
            class="text-sm cursor-pointer mx-4 p-2"
            (click)="onClick('EMPLOYERS_OPINIONS', '/avis-employeurs')"
          >
            <p>Avis des employeurs</p>
          </div>
          <div
            [ngClass]="
              activeRoute === 'LEARNING_OFFERS'
                ? 'bg-percian-green rounded-lg text-white'
                : 'bg-white text-black'
            "
            class="text-sm cursor-pointer mx-4 p-2"
            (click)="onClick('LEARNING_OFFERS', '/offres-d-apprentissage')"
          >
            <p>Offres d'apprentissages</p>
          </div>
        </div>
        <div class="hidden lg:block absolute -bottom-12 -left-5">
          <img src="assets/svg/avatar-15.svg" alt="Illustration Cfa santé" />
        </div>
        <div class="mx-auto">
          <img
            class="h-8 cursor-pointer lg:hidden"
            src="assets/svg/cross.svg"
            (click)="closeMenu()"
            alt="Fermer"
          />
        </div>
      </div>
    </div>
  </div>
</div>
